import React from 'react';
import { PropTypes } from 'prop-types';

const HintButtonComponent = ({
  hintType,
  active,
  onClick,
  buttonBackground
}) => (
  <button
    id="hintButton"
    type="button"
    onClick={ () => onClick() }
    style={ { backgroundColor: active ? '#1f3460' : buttonBackground } }
  >
    <svg id="svgIcon" style={ { fill: active ? '#fff' : '#1f3460' } }>
      <use xlinkHref={ `assets/images/hint-defs.svg#${ hintType }-icon` } />
    </svg>
  </button>
);

HintButtonComponent.propTypes = {
  hintType: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonBackground: PropTypes.string
};

HintButtonComponent.defaultProps = {
  buttonBackground: 'rgba(255, 255, 255, .75)'
};

export default HintButtonComponent;
